import { render } from "./sectionTeam.vue?vue&type=template&id=1309ef62&scoped=true"
import script from "./sectionTeam.vue?vue&type=script&lang=js"
export * from "./sectionTeam.vue?vue&type=script&lang=js"

import "./sectionTeam.vue?vue&type=style&index=0&id=1309ef62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1309ef62"]])

export default __exports__